// src/components/profile/TagChip.jsx

import React from 'react';
import { Chip } from '@material-ui/core';
import { COLORS, useProfileStyles } from './profileStyles';

const tagColorMap = {
  purple: {
    bg: COLORS.purpleBg,
    color: COLORS.primary,
  },
  blue: {
    bg: COLORS.blueBg,
    color: '#0969DA',
  },
  green: {
    bg: COLORS.greenBg,
    color: '#0E8A44',
  },
  orange: {
    bg: COLORS.orangeBg,
    color: '#EA580C',
  },
  red: {
    bg: COLORS.redBg,
    color: COLORS.secondary,
  },
};

const TagChip = ({
  label,
  color = 'purple',
  icon,
}) => {
  const classes = useProfileStyles();

  const selectedColor = tagColorMap[color] || tagColorMap.purple;

  return (
    <Chip
      label={label}
      icon={icon}
      className={classes.tag}
      style={{
        background: selectedColor.bg,
        color: selectedColor.color,
      }}
    />
  );
};

export default TagChip;